// One-page navigation: marks the menu item of the section in view with
// .is-active and closes the mobile menu after an anchor link is clicked
let _this = (module.exports = {
	// Set the dom elements
	dom: {
		navbar: document.getElementById('navbar'),
	},

	/**
	 * Init functions
	 */
	init: function () {
		if (!_this.dom.navbar) {
			return;
		}

		var links = _this.dom.navbar.querySelectorAll('a[href^="#"]');
		if (!links.length) {
			return;
		}

		var items = [];
		links.forEach(function (link) {
			var href = link.getAttribute('href');
			var section = href && href.length > 1 ? document.querySelector(href) : null;
			var item = link.closest('.theme-menu-content .menu-item');

			// Close the mobile menu once a section is picked
			link.addEventListener('click', function () {
				_this.dom.navbar.classList.remove('open');
			});

			if (section && item) {
				items.push({ section: section, item: item });
			}
		});

		if (!items.length || !('IntersectionObserver' in window)) {
			return;
		}

		var observer = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					if (!entry.isIntersecting) {
						return;
					}
					items.forEach(function (row) {
						row.item.classList.toggle('is-active', row.section === entry.target);
					});
				});
			},
			// A section counts as "in view" when it crosses the middle of the screen
			{ rootMargin: '-45% 0px -50% 0px' },
		);

		items.forEach(function (row) {
			observer.observe(row.section);
		});
	},
});
